import { __read } from "tslib";
import { Subscriber } from './Subscriber';
import { observable as Symbol_observable } from './symbol/observable';
import { pipeFromArray } from './util/pipe';
var Observable = (function () {
    function Observable(subscribe) {
        if (subscribe) {
            this._subscribe = subscribe;
        }
    }
    Observable.prototype.subscribe = function (observerOrNext) {
        var subscriber = observerOrNext instanceof Subscriber ? observerOrNext : new Subscriber(observerOrNext);
        subscriber.add(this._trySubscribe(subscriber));
        return subscriber;
    };
    Observable.prototype._trySubscribe = function (sink) {
        try {
            return this._subscribe(sink);
        }
        catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function (next) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var subscriber = new Subscriber({
                next: function (value) {
                    try {
                        next(value);
                    }
                    catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve,
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function (_subscriber) {
        return;
    };
    Observable.prototype[Symbol_observable] = function () {
        return this;
    };
    Observable.prototype.pipe = function () {
        var operations = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operations[_i] = arguments[_i];
        }
        return pipeFromArray(operations)(this);
    };
    Observable.prototype[Symbol.asyncIterator] = function () {
        var _a;
        var _this = this;
        var subscription;
        var hasError = false;
        var error;
        var completed = false;
        var values = [];
        var deferreds = [];
        var handleError = function (err) {
            hasError = true;
            error = err;
            while (deferreds.length) {
                var _a = __read(deferreds.shift(), 2), _1 = _a[0], reject = _a[1];
                reject(err);
            }
        };
        var handleComplete = function () {
            completed = true;
            while (deferreds.length) {
                var _a = __read(deferreds.shift(), 1), resolve = _a[0];
                resolve({ value: undefined, done: true });
            }
        };
        return _a = {
                next: function () {
                    if (!subscription) {
                        subscription = _this.subscribe({
                            next: function (value) {
                                if (deferreds.length) {
                                    var _a = __read(deferreds.shift(), 1), resolve = _a[0];
                                    resolve({ value: value, done: false });
                                }
                                else {
                                    values.push(value);
                                }
                            },
                            error: handleError,
                            complete: handleComplete,
                        });
                    }
                    if (values.length) {
                        return Promise.resolve({ value: values.shift(), done: false });
                    }
                    if (completed) {
                        return Promise.resolve({ value: undefined, done: true });
                    }
                    if (hasError) {
                        return Promise.reject(error);
                    }
                    return new Promise(function (resolve, reject) {
                        deferreds.push([resolve, reject]);
                    });
                },
                throw: function (err) {
                    subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
                    handleError(err);
                    return Promise.reject(err);
                },
                return: function () {
                    subscription === null || subscription === void 0 ? void 0 : subscription.unsubscribe();
                    handleComplete();
                    return Promise.resolve({ value: undefined, done: true });
                }
            },
            _a[Symbol.asyncIterator] = function () {
                return this;
            },
            _a;
    };
    return Observable;
}());
export { Observable };
//# sourceMappingURL=Observable.js.map